import React from 'react';
import PropTypes from 'prop-types';

import { vehicleImageUrl } from '../../library/fitment/fitment-utils';

import { TRAILER } from '../../shared/constants/fitment';

import './vehicle-image.scss';

function VehicleImage(props) {
  const { smallImageUrl = null, className, alt = '', vehicleType } = props;

  const imgSrc = vehicleImageUrl(
    smallImageUrl,
    vehicleType === TRAILER ? 'TLR' : 'PAS'
  );

  return (
    <div
      className={`${className || ''} vehicle-image`}
      styleName="vehicle-display image"
    >
      <img alt={alt} src={imgSrc} />
    </div>
  );
}
VehicleImage.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  smallImageUrl: PropTypes.string,
  vehicleType: PropTypes.string
};

export default VehicleImage;
